export const GET_EPG = 'epg::GET_EPG';
export const GET_EPG_REQUEST = 'epg::GET_EPG_REQUEST';
export const SET_EPG_REQUEST_IDLE_STATUS = 'epg::SET_EPG_REQUEST_IDLE_STATUS';
export const GET_EPG_SUCCESS = 'epg::GET_EPG_SUCCESS';
export const GET_EPG_FAILURE = 'epg::GET_EPG_FAILURE';
export const SET_FULLSCREEN = 'epg::SET_FULLSCREEN';
export const SET_PREVIOUSLY_WATCHED_CHANNEL =
    'epg::SET_PREVIOUSLY_WATCHED_CHANNEL';
export const GET_EPG_BY_VISIBLE_CHANNELS = 'epg::GET_EPG_BY_VISIBLE_CHANNELS';
export const GET_EPG_BY_VISIBLE_CHANNELS_REQUEST =
    'epg::GET_EPG_BY_VISIBLE_CHANNELS_REQUEST';
export const GET_EPG_BY_VISIBLE_CHANNELS_SUCCESS =
    'epg::GET_EPG_BY_VISIBLE_CHANNELS_SUCCESS';
export const SET_EPG_DATE = 'epg::SET_EPG_DATE';
export const SET_SUBTITLES_DIALOG_VISIBLE = 'epg::SET_SUBTITLES_DIALOG_VISIBLE';

export const GET_EPG_PARTIAL_UPDATE = 'epg::GET_EPG_PARTIAL_UPDATE';
export const GET_EPG_PARTIAL_UPDATE_REQUEST =
    'epg::GET_EPG_PARTIAL_UPDATE_REQUEST';
export const GET_EPG_PARTIAL_UPDATE_SUCCESS =
    'epg::GET_EPG_PARTIAL_UPDATE_SUCCESS';
export const GET_EPG_PARTIAL_UPDATE_FAILURE =
    'epg::GET_EPG_PARTIAL_UPDATE_FAILURE';

export const SET_FOCUS_TO_NOW = 'epg::SET_FOCUS_TO_NOW';

export const SET_EPG_LAST_UPDATED = 'epg::SET_EPG_LAST_UPDATED';

export const SET_EPG_SELECTED_LAYOUT = 'epg::SET_EPG_SELECTED_LAYOUT';
